/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SignalREventNames = {
    ImageGenerationSucceeded: 'ImageGenerationSucceeded',
    ImageGenerationFailed: 'ImageGenerationFailed',
    ImageGenerationProgress: 'ImageGenerationProgress',
    SummarizationSucceeded: 'SummarizationSucceeded',
    SummarizationFailed: 'SummarizationFailed',
    SummarizationProgress: 'SummarizationProgress',
    TranscriptionSucceeded: 'TranscriptionSucceeded',
    TranscriptionFailed: 'TranscriptionFailed',
    TranscriptionProgress: 'TranscriptionProgress',
    TranslationSucceeded: 'TranslationSucceeded',
    TranslationFailed: 'TranslationFailed',
    TranslationProgress: 'TranslationProgress',
    UploadFileSucceeded: 'UploadFileSucceeded',
    UploadFileFailed: 'UploadFileFailed',
    UploadFileProgress: 'UploadFileProgress'
} as const;
export type SignalREventNames = typeof SignalREventNames[keyof typeof SignalREventNames];


export function instanceOfSignalREventNames(value: any): boolean {
    for (const key in SignalREventNames) {
        if (Object.prototype.hasOwnProperty.call(SignalREventNames, key)) {
            if (SignalREventNames[key as keyof typeof SignalREventNames] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SignalREventNamesFromJSON(json: any): SignalREventNames {
    return SignalREventNamesFromJSONTyped(json, false);
}

export function SignalREventNamesFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignalREventNames {
    return json as SignalREventNames;
}

export function SignalREventNamesToJSON(value?: SignalREventNames | null): any {
    return value as any;
}

export function SignalREventNamesToJSONTyped(value: any, ignoreDiscriminator: boolean): SignalREventNames {
    return value as SignalREventNames;
}

